import React from 'react';

import { getTypographyForSx } from 'src/theme';
import { makeStyles } from 'tss-react/mui';

import type { MarkdownComponentProps } from '../ChatPanelMarkdown';

export const useStyles = makeStyles()(theme => ({
  paragraph: {
    ...getTypographyForSx(theme.typography.body1),
    wordBreak: 'break-word',
  },
}));

export const ParagraphElement = React.memo(function ParagraphElement(
  props: MarkdownComponentProps<HTMLParagraphElement>
): JSX.Element {
  const { classes } = useStyles();
  return <p {...props} className={classes.paragraph} />;
});
